<div class="container-fluid">
  <h4>{{ 'Markets.General.header' | translate }}</h4>
  <h5>{{ 'Markets.General.subHeader' | translate }}</h5>
  <p>{{ 'Markets.General.shordDescriptionP1' | translate }}</p>
  <p>{{ 'Markets.General.shordDescriptionP2' | translate }}</p>
  <div class="row mt-4">
    <mat-form-field class="col-lg-11 col-md-10 col-sm-9">
      <mat-label>{{ 'Markets.General.lblGenMarkets' | translate }}</mat-label>
      <mat-select name="market">
        @for (market of generalMarkets; track market) {
          <mat-option [value]="market.id" (click)="OnChangeMarket(market.id)">
            {{ market.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="col-lg-1 col-md-2 col-sm-3 col-12">
      @if (service.currentUser.isReadOnly === false && service.currentUser.userRole !== operatorRoleName) {
        <button class="matbtnNew" mat-raised-button (click)="OnCreateMarket()"> {{ 'btnNew' | translate }} </button>
      }
    </div>
  </div>
  @if (isSelected) {
    <div [@slider]="isSelected? 'show' : null" class="slider">
      <mat-tab-group dynamicHeight mat-align-tabs="start" mat-stretch-tabs="false" animationDuration="1000ms">
        @if (service.currentUser.userRole === operatorRoleName || service.currentUser.userRole === adminRoleName || service.currentUser.userRole === complianceRoleName) {
          <mat-tab label="{{ 'Markets.General.lblProperties' | translate }}">
            <div class="mt-1">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblCode' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'Markets.General.lblCode' | translate }}" [(ngModel)]="selectedMarket.code" [ngModelOptions]="{standalone: true}" required maxlength="10" />
                  </mat-form-field>
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblDescription' | translate }}</mat-label>
                    <input type="text" matInput placeholder="{{ 'Markets.General.lblDescription' | translate }}" [(ngModel)]="selectedMarket.description" [ngModelOptions]="{standalone: true}" required />
                  </mat-form-field>
                  <div class="row">
                    <mat-form-field class="col-6" style="padding-left: 30px;">
                      <mat-label>{{ 'Markets.General.lblConDecPlaces' | translate }}</mat-label>
                      <input type="number" matInput placeholder="{{ 'Markets.General.lblConDecPlaces' | translate }}" [(ngModel)]="selectedMarket.contributionDecimalPlaces" [ngModelOptions]="{standalone: true}" required />
                    </mat-form-field>
                    <mat-form-field class="col-6" style="padding-right: 30px;">
                      <mat-label>{{ 'Markets.General.lblCalDecPlaces' | translate }}</mat-label>
                      <input type="number" matInput placeholder="{{ 'Markets.General.lblCalDecPlaces' | translate }}" [(ngModel)]="selectedMarket.calculationDecimalPlaces" [ngModelOptions]="{standalone: true}" required />
                    </mat-form-field>
                  </div>
                  <div class="row">
                    <mat-form-field class="col-6" style="padding-left: 30px;">
                      <mat-label>{{ 'Markets.General.lblCalType' | translate }}</mat-label>
                      <mat-select [(ngModel)]="selectedMarket.listCalculationId" [ngModelOptions]="{standalone: true}" required>
                        @for (calType of calculationTypes; track calType) {
                          <mat-option [value]="calType.id">{{ calType.value }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-6" style="padding-right: 30px;">
                      <mat-label>{{ 'Markets.General.lblSpikeCalPeriod' | translate }}</mat-label>
                      <input type="number" step="1" min="0" matInput placeholder="{{ 'Markets.General.lblSpikeCalPeriod' | translate }}" [(ngModel)]="selectedMarket.dynamicSpikePeriod" [ngModelOptions]="{standalone: true}" required />
                    </mat-form-field>
                  </div>
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblRounding' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedMarket.listRoundingId" [ngModelOptions]="{standalone: true}" required>
                      @for (rounding of roundings; track rounding) {
                        <mat-option [value]="rounding.id">{{ rounding.value }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field [@slider]="(selectedMarket.transactional === true)? 'show' : '*'" class="slider col-12">
                    <mat-label>{{ 'Markets.General.lblMinVol' | translate }}</mat-label>
                    <input type="number" step="1" min="0" matInput placeholder="{{ 'Markets.General.lblMinVol' | translate }}" [(ngModel)]="selectedMarket.minimumVolume" [ngModelOptions]="{standalone: true}" required />
                  </mat-form-field>
                  @if (currencies.length > 0) {
                    <mat-form-field [@slider]="(currencies.length > 0 && selectedMarket.transactional === true)? 'show' : '*'" class="slider col-12">
                      <mat-label>{{ 'Markets.General.lblCurrency' | translate }}</mat-label>
                      <mat-select [(ngModel)]="selectedMarket.currencyId" [ngModelOptions]="{standalone: true}" required>
                        @for (currency of currencies; track currency) {
                          <mat-option [value]="currency.id">{{ currency.value }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <div class="row m-0">
                    <div class="col-lg-6 col-sm-12">
                      <mat-checkbox color="primary" [(ngModel)]="selectedMarket.transactional" [ngModelOptions]="{standalone: true}">
                        {{ 'Markets.General.chbxTransactional' | translate }}
                      </mat-checkbox>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                      <mat-checkbox color="primary" [(ngModel)]="selectedMarket.hidden" [ngModelOptions]="{standalone: true}">
                        {{ 'Markets.General.ckbxHideCon' | translate }}
                      </mat-checkbox>
                    </div>
                  </div>
                  <div class="row m-0">
                      <div class="col-lg-6 col-sm-12">
                          <mat-checkbox color="primary" [(ngModel)]="selectedMarket.contributionPartial" [ngModelOptions]="{standalone: true}">
                              {{ 'Markets.General.ckbxAllowParCon' | translate }}
                          </mat-checkbox>
                      </div>
                      <div class="col-lg-6 col-sm-12">
                          <mat-checkbox color="primary" [(ngModel)]="selectedMarket.disabled" [ngModelOptions]="{standalone: true}">
                              {{ 'Markets.General.ckbxDisabled' | translate }}
                          </mat-checkbox>
                      </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblQuorumFailure' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedMarket.listQuorumId" [ngModelOptions]="{standalone: true}" required>
                      @for (quorum of quorums; track quorum) {
                        <mat-option [value]="quorum.id">{{ quorum.value }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblQuorumThres' | translate }}</mat-label>
                    <input type="number" matInput placeholder="{{ 'Markets.General.lblQuorumThres' | translate }}" [(ngModel)]="selectedMarket.quorum" [ngModelOptions]="{standalone: true}" required />
                  </mat-form-field>
                  <div class="row">
                    <mat-form-field class="{{ isRepetitionMonthly || isRepetitionWeekly ? 'col-6' : 'col-12' }} ml-3">
                      <mat-label>{{ 'Markets.General.lblRepetition' | translate }}</mat-label>
                      <mat-select [(ngModel)]="selectedMarket.listRepetitionId" [ngModelOptions]="{standalone: true}" required>
                        @for (repetition of repetitions; track repetition) {
                          <mat-option [value]="repetition.id" (click)="onChangeRepetition(repetition.value)">
                            {{ repetition.value }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <div class="col-4">
                      @if (isRepetitionMonthly) {
                        <mat-form-field class="col-12 slider" [@slider]="isRepetitionMonthly? 'show' : null">
                          <mat-label>{{ 'Markets.General.lblRepDay' | translate }}</mat-label>
                          <input type="number" matInput placeholder="{{ 'Markets.General.lblRepDay' | translate }}" [(ngModel)]="selectedMarket.repetitionDay" [ngModelOptions]="{standalone: true}" required min="-31" max="31" />
                        </mat-form-field>
                      }
                      @if (isRepetitionWeekly) {
                        <mat-form-field class="col-12 slider" [@slider]="isRepetitionWeekly? 'show' : null">
                          <mat-label>{{ 'Markets.General.lblRepDay' | translate }}</mat-label>
                          <mat-select [(ngModel)]="selectedMarket.repetitionDay" [ngModelOptions]="{standalone: true}" required>
                            <mat-option [value]="1">Monday</mat-option>
                            <mat-option [value]="2">Tuesday</mat-option>
                            <mat-option [value]="3">Wednesday</mat-option>
                            <mat-option [value]="4">Thursday</mat-option>
                            <mat-option [value]="5">Friday</mat-option>
                          </mat-select>
                        </mat-form-field>
                      }
                    </div>
                  </div>
                  <fieldset class="col-12">
                    <legend>{{ 'Markets.General.lblConWinTime' | translate }} *</legend>
                    <div class="row">
                      <ngx-timepicker-field class="col-xl-5 col-lg-12 col-sm-5" [(ngModel)]="selectedMarket.contributionStart" [ngModelOptions]="{standalone: true}" required></ngx-timepicker-field>
                      <span class="col-xl-1 col-lg-12 col-sm-1">to</span>
                      <ngx-timepicker-field class="col-xl-6 col-lg-12 col-sm-6" [(ngModel)]="selectedMarket.contributionFinish" [ngModelOptions]="{standalone: true}" required></ngx-timepicker-field>
                    </div>
                  </fieldset>
                  <fieldset class="col-12">
                    <legend>{{ 'Markets.General.lblCalTime' | translate }} *</legend>
                    <div class="row">
                      <ngx-timepicker-field class="col-xl-5 col-lg-12 col-sm-5" [(ngModel)]="selectedMarket.calculationTime" [ngModelOptions]="{standalone: true}" required></ngx-timepicker-field>
                      <span class="col-xl-1 col-lg-12 col-sm-1"></span>
                      <mat-checkbox class="col-xl-6 col-lg-12 col-sm-6" color="primary" [(ngModel)]="selectedMarket.publishCalCon" [ngModelOptions]="{standalone: true}">
                        {{ 'Markets.General.ckbxPblshCon' | translate }}
                      </mat-checkbox>
                    </div>
                  </fieldset>
                  <fieldset class="col-12">
                    <legend>{{ 'Markets.General.lblOvrrideTime' | translate }} *</legend>
                    <div class="row">
                      <ngx-timepicker-field class="col-xl-5 col-lg-12 col-sm-5" [(ngModel)]="selectedMarket.overrideFinish" [ngModelOptions]="{standalone: true}" required></ngx-timepicker-field>
                    </div>
                  </fieldset>
                  <fieldset class="col-12">
                    <legend>{{ 'Markets.General.lblRefixTime' | translate }}</legend>
                    <div class="row">
                      <div class="col-xl-6 col-lg-12 col-sm-6" style="display: flex;">
                        <ngx-timepicker-field [(ngModel)]="selectedMarket.refixTime" [ngModelOptions]="{standalone: true}" required>
                        </ngx-timepicker-field>
                        <span><mat-icon (click)="OnClickRefixReset()" class="clickable text-secondary refixCancel" matTooltip="Reset refix time">cancel</mat-icon></span>
                      </div>
                      <mat-checkbox class="col-xl-6 col-lg-12 col-sm-6" color="primary" [(ngModel)]="selectedMarket.publishRefixCon" [ngModelOptions]="{standalone: true}">
                        {{ 'Markets.General.ckbxPblshCon' | translate }}
                      </mat-checkbox>
                    </div>
                  </fieldset>
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblConVeri' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedMarket.listVerificationId" [ngModelOptions]="{standalone: true}" required>
                      @for (verification of verifications; track verification) {
                        <mat-option [value]="verification.id">
                          {{ verification.value }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="col-12">
                    <mat-label>{{ 'Markets.General.lblNxtCalDate' | translate }}</mat-label>
                    <input matInput [matDatepicker]="dp3" readonly [(ngModel)]="selectedMarket.nextCalculation" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                    <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-tab>
        }
        @if (service.currentUser.userRole === operatorRoleName || service.currentUser.userRole === adminRoleName || service.currentUser.userRole === complianceRoleName) {
          <mat-tab label="{{ 'Markets.General.headerInstruments' | translate }}">
            @if (service.currentUser.userRole !== operatorRoleName || service.currentUser.isReadOnly === false) {
              <button mat-raised-button (click)="OnCreateInstrument()">
                <mat-icon>add</mat-icon> {{ 'Markets.General.btnNewIns' | translate }}
              </button>
            }
            <div class="mat-elevation-z8">
              <div class="scrollableTable">
                <table mat-table [dataSource]="dataSource" matSort matSortActive="term" matSortDirection="asc">
                  <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 15%;">
                      {{ 'Markets.General.thCode' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.code }}</td>
                  </ng-container>
                  <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ 'Markets.General.thDescription' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                  </ng-container>
                  <ng-container matColumnDef="term">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;">
                      {{ 'Markets.General.thTerm' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.term }}</td>
                  </ng-container>
                  <ng-container matColumnDef="spread">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;">
                      {{ 'Markets.General.thSpread' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.spread }}</td>
                  </ng-container>
                  <ng-container matColumnDef="calType">
                    <th mat-header-cell *matHeaderCellDef style="width: 15%;">
                      {{ 'Markets.General.thCalType' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.calculationType.value }}</td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: center;">
                      {{ 'thActions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <button mat-icon-button color="primary" (click)="OnEditInstrument(element)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      &nbsp;
                      @if (service.currentUser.userRole !== operatorRoleName) {
                        <button mat-icon-button color="warn" (click)="OnDeleteInstrument(element)">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                      {{ 'tblLoading' | translate }}...
                    </th>
                  </ng-container>
                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                      {{ 'Markets.General.tblInsNoData' | translate }}...
                    </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSource!=null}"></tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':dataSource!=null && instrumentsLength != 0}"></tr>
                </table>
              </div>
              <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25]" [length]="instrumentsLength"></mat-paginator>
            </div>
          </mat-tab>
        }
        <mat-tab label="{{ 'Markets.General.lblTabContributors' | translate }}">
          <div class="">
            <div style="height: 100%; font-size: small;">
              <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl" class="example-tree">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                  <li class="mat-tree-node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <button mat-icon-button><mat-icon>{{ node.maticon }}</mat-icon></button>
                    <mat-checkbox color="primary" #ckbx [(ngModel)]="node.checked" [ngModelOptions]="{standalone: true}" (change)="OnClickRecipient(node.id, ckbx.checked)">
                      {{ node.name }}
                    </mat-checkbox>
                  </li>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <li>
                    <div class="mat-tree-node">
                      <button mat-icon-button><mat-icon>{{ node.maticon }}</mat-icon></button>
                      <mat-label class="clickable" matTreeNodeToggle> {{ node.name }}</mat-label>
                      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                          {{ treeControl.isExpanded(node) ? "expand_less" : "expand_more" }}
                        </mat-icon>
                      </button>
                    </div>
                    <ul [@slider]="treeControl.isExpanded(node) ? 'show' : null">
                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
                  </li>
                </mat-nested-tree-node>
              </mat-tree>
            </div>
          </div>
        </mat-tab>
        @if (service.currentUser.userRole === operatorRoleName || service.currentUser.userRole === adminRoleName || service.currentUser.userRole === complianceRoleName) {
          <mat-tab label="{{ 'Markets.General.lblTabTests' | translate }}">
            <div class="mat-elevation-z8">
              <div class="scrollableTable">
                <table mat-table [dataSource]="dataSourceTests">
                  <ng-container matColumnDef="test">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Markets.General.thTestName' | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                  </ng-container>
                  <ng-container matColumnDef="enabled">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%;">{{ 'Markets.General.ckbxEnabled' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true" [checked]="element.enabled" (change)="element.enabled = !element.enabled; element.enabled == false ? element.verbose = element.enabled : true;"></mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="verbose">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%;">{{ 'Markets.General.thVerbose' | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox color="primary" [disabled]="service.currentUser.isReadOnly === true || element.enabled === false" [checked]="element.verbose" (change)="element.verbose = !element.verbose"></mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef style="width: 10%; text-align: center;">
                      {{ 'thActions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: center;">
                      <button mat-icon-button color="primary" (click)="OnEditTest(element)" [disabled]="element.enabled === false">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="loading">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                      {{ 'tblLoading' | translate }}...
                    </th>
                  </ng-container>
                  <ng-container matColumnDef="noData">
                    <th class="loading" mat-footer-cell *matFooterCellDef colspan="12">
                      {{ 'Markets.General.tblTestsNoData' | translate }}...
                    </th>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayColumnsTests; sticky: true"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayColumnsTests;"></tr>
                  <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':dataSourceTests!=null}"></tr>
                  <tr mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':dataSourceTests!=null && testslength != 0}"></tr>
                </table>
              </div>
            </div>
          </mat-tab>
        }
        @if (service.currentUser.userRole === adminRoleName || service.currentUser.userRole === complianceRoleName) {
          <mat-tab label="{{ 'Markets.General.lblTabXml' | translate }}">
            @if (selectedMarket.xmlMarkup && selectedMarket.xmlMarkup.length > 0) {
              <div class="mt-1">
                  <ngx-codemirror [(ngModel)]="selectedMarket.xmlMarkup[0].content" [options]="{
                lineNumbers: true,
                theme: 'expert',
                mode: 'text/xml',
                autoRefresh: true,
                autoCloseTags: true,
                lineWrapping : false,
                styleActiveLine: true,
                fixedGutter: true,
                lint: true,
                coverGutterNextToScrollbar: false,
                matchTags: { bothTags: true }
              }"></ngx-codemirror>
                <div class="row">
                  <mat-checkbox style="margin-left:30px;" color="primary" [(ngModel)]="selectedMarket.xmlMarkup[0].enabled" [ngModelOptions]="{standalone: true}">
                    {{ 'Markets.General.ckbxEnabled' | translate }}
                  </mat-checkbox>
                </div>
              </div>
            }
          </mat-tab>
        }
      </mat-tab-group>
      @if (service.currentUser.isReadOnly === false) {
        <div class="mt-2">
          <button mat-raised-button style="float: right; margin-left: 10px;" color="primary" type="button" (click)="OnSaveMarket()">
            {{ 'btnSave' | translate }}
          </button>
          <button [disabled]="service.currentUser.userRole === operatorRoleName" mat-raised-button style="float: right;" color="secondary" type="button" (click)="OnDeleteMarket()">
            {{ 'btnDelete' |translate }}
          </button>
        </div>
      }
    </div>
  }
</div>
